export const setTiposInstituicoesToSelect = (data) =>
  sessionStorage.setItem("tipos_instituicoes", JSON.stringify(data));
export const getTiposInstituicoesToSelect = () =>
  JSON.parse(sessionStorage.getItem("tipos_instituicoes"));
